<template>
  <div class="l-page">
    <header
      class="header"
      :class="{ open: showMenu }">
      <div class="container">
        <div class="header__inner">
          <a
            href="#"
            class="header__logo">
            <img
              src="@/assets/images/nto_logo_white.png"
              alt=""
              class="header__logo-square" />
            <img
              src="@/assets/images/logo-horizontal_white.png"
              alt=""
              class="header__logo-horizontal" />
          </a>
          <button
            class="header__burger burger"
            :class="{ active: showMenu }"
            @click="handleBurger">
            <div class="burger__line"></div>
          </button>
          <nav
            class="header__nav"
            :class="{ active: showMenu }">
            <a
              class="header__nav-item"
              href="#about"
              >Об&nbsp;олимпиаде</a
            >
            <a
              class="header__nav-item"
              href="#participants"
              >Участникам</a
            >
            <!-- <a class="header__nav-item" href="#steps">Этапы</a> -->
            <a
              class="header__nav-item"
              href="#preparation"
              >Подготовка</a
            >
            <a
              class="header__nav-item"
              href="#to-mentors-and-teachers"
              >Наставникам и учителям</a
            >
          </nav>
          <BviButton
            theme="white"
            class="special-button" />
        </div>
      </div>
    </header>

    <video
      class="video"
      autoplay
      muted
      loop
      lazy
      playsinline>
      <source
        src="https://storage.yandexcloud.net/onti-public/media/NTO_landing_bg_1.mp4"
        type="video/mp4" />
    </video>

    <main id="main-content">
      <Hero
        :start-date="startDate"
        :reg-url="regLink"
        :pre-reg-url="preRegUrl"
        :is-all-reg-closed="isAllRegClosed"
        :start-duration="startDuration"
        :loading="loading"
        :login-url="loginUrl"></Hero>

      <section class="section">
        <Swiper
          class="features-slider"
          :options="swiperOptions">
          <SwiperSlide class="features-slider__slide">
            <div class="features-slider__slide-img">
              <img
                src="@/assets/images/landing/slider/slide1.jpg"
                width="376"
                height="220"
                alt="Реальные задания" />
            </div>
            <p>Реальные задания</p>
          </SwiperSlide>
          <SwiperSlide class="features-slider__slide">
            <div class="features-slider__slide-img">
              <img
                src="@/assets/images/landing/slider/slide2.png"
                width="376"
                height="220"
                alt="Работа в команде" />
            </div>
            <p>Работа в команде</p>
          </SwiperSlide>
          <SwiperSlide class="features-slider__slide">
            <div class="features-slider__slide-img">
              <img
                src="@/assets/images/landing/slider/slide3.jpg"
                width="376"
                height="220"
                alt="Технологии" />
            </div>
            <p>Технологии</p>
          </SwiperSlide>
          <SwiperSlide class="features-slider__slide">
            <div class="features-slider__slide-img">
              <img
                src="@/assets/images/landing/slider/slide4.jpg"
                width="376"
                height="220"
                alt="Единомышленники" />
            </div>
            <p>Единомышленники</p>
          </SwiperSlide>
          <SwiperSlide class="features-slider__slide">
            <div class="features-slider__slide-img">
              <img
                src="@/assets/images/landing/slider/slide5.jpg"
                width="376"
                height="220"
                alt="" />
            </div>
            <p>Ведущие инженерные вузы</p>
          </SwiperSlide>
          <SwiperSlide class="features-slider__slide">
            <div class="features-slider__slide-img">
              <img
                src="@/assets/images/landing/slider/slide6.jpeg"
                width="376"
                height="220"
                alt="" />
            </div>
            <p>Научные лаборатории</p>
          </SwiperSlide>
          <SwiperSlide class="features-slider__slide">
            <div class="features-slider__slide-img">
              <img
                src="@/assets/images/landing/slider/slide7.jpg"
                width="376"
                height="220"
                alt="Знакомство с профессиями" />
            </div>
            <p>Знакомство с профессиями</p>
          </SwiperSlide>
          <SwiperSlide class="features-slider__slide">
            <div class="features-slider__slide-img">
              <img
                src="@/assets/images/landing/slider/slide8.jpg"
                width="376"
                height="220"
                alt="Единомышленники" />
            </div>
            <p>Единомышленники</p>
          </SwiperSlide>
        </Swiper>
      </section>

      <section
        id="about"
        class="section about">
        <div class="container about__box">
          <h2 class="landing__title h2">Об&nbsp;олимпиаде</h2>
          <div class="about__row">
            <div
              v-for="(item, idx) in ABOUT_NTO"
              :key="idx"
              class="about__cell">
              <p
                class="about__count-number"
                v-html="item.count" />
              <div class="about__cell-block">
                <p
                  class="about__cell-header"
                  v-html="item.cellHeader" />
                <div class="about__cell-footer">
                  <p v-html="item.cellFooter[0]" />
                  <p v-html="item.cellFooter[1]" />
                </div>
              </div>
            </div>
          </div>
          <div class="about__panel">
            <img
              src="@/assets/images/landing/about/heart.svg"
              alt="nto-heart"
              class="about__panel-img" />
            <div class="about__panel-box">
              <p class="about__panel-title">Цели НТО</p>
              <ul class="about__panel-list">
                <li
                  v-for="goal in NTO_GOALS"
                  :key="goal"
                  class="about__panel-list-item">
                  <img
                    alt=""
                    src="@/assets/images/landing/about/cube.svg" />
                  <p v-html="goal" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="about__tags">
          <p
            v-for="tag in TAGS"
            :key="tag"
            class="about__tag"
            v-html="tag" />
        </div>
      </section>

      <section
        id="participants"
        class="container tracks">
        <h2 class="landing__title h2">Соревновательные треки НТО</h2>
        <p class="tracks__subtitle">
          Стань участником и&nbsp;прояви себя в&nbsp;финале!
        </p>
        <ul class="tracks__list">
          <li
            v-for="track in TRACKS"
            :key="track.title"
            class="tracks__item">
            <img
              :alt="track.title"
              :src="track.src" />
            <div class="tracks__item-box">
              <p class="tracks__item-title">{{ track.title }}</p>
              <p
                class="tracks__item-for"
                v-html="track.for" />
              <ul class="tracks__item-list">
                <li
                  v-for="i in track.list"
                  :key="i"
                  class="tracks__item-list-item">
                  <span>✦</span><span v-html="i" />
                </li>
              </ul>
              <a
                class="tracks__item-link"
                :href="track.link"
                target="_blank"
                rel="noopener noreferrer"
                >Подробнее</a
              >
            </div>
          </li>
        </ul>
        <div
          v-if="showRegButtons"
          class="tracks__buttons">
          <BaseButton
            v-if="regLink"
            tag="a"
            size="lg"
            theme="primary"
            :href="regLink"
            class="tracks__btn-reg"
            @click="
              gtmEvent({
                eventLabel: 'slider_block',
                eventAction: 'go_to_registration',
              })
            "
            >Зарегистрироваться</BaseButton
          >

          <BaseButton
            v-if="loginUrl"
            tag="a"
            size="lg"
            theme="reg"
            :href="loginUrl"
            class="tracks__hero-btn"
            @click="
              gtmEvent({
                eventLabel: 'slider_block',
                eventAction: 'go_to_enter_account',
              })
            "
            >войти в учетную запись</BaseButton
          >
        </div>
      </section>

      <section class="container bonuses">
        <h2 class="landing__title h2">Дополнительные бонусы</h2>
        <ul class="bonuses__list">
          <li
            v-for="bonus in BONUSES"
            :key="bonus.title"
            class="bonuses__item">
            <img
              :src="bonus.src"
              :alt="bonus.title" />
            <div class="bonuses__item-content">
              <p
                class="bonuses__item-title"
                v-html="bonus.title" />
              <p
                class="bonuses__item-description"
                v-html="bonus.description" />
              <div
                v-if="bonus.details"
                class="bonuses__item-details">
                <div
                  v-for="(detail, idx) in bonus.details"
                  :key="idx"
                  class="bonuses__item-detail">
                  <p v-html="detail.title" />
                  <p v-html="detail.description" />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </section>

      <section
        id="past-olympiad"
        class="past-olympiad">
        <div
          class="video-poster"
          @click.prevent="showModal"></div>
        <!-- <a
          class="past-olympiad__btn"
          href="#"
          @click.prevent="showModal"
          >Посмотри, как проходит олимпиада</a
        > -->
      </section>

      <div class="container">
        <section
          id="preparation"
          class="section prep">
          <h2 class="h2 landing__title">Подготовка для участников</h2>
          <div class="prep__row">
            <div class="prep__item">
              <h3 class="prep__item-title h4">Площадки подготовки</h3>
              <h4 class="prep__item-subtitle">
                Площадки подготовки к&nbsp;НТО есть во&nbsp;многих регионах
                России.
              </h4>
              <BaseButton
                tag="a"
                href="https://ntcontest.ru/study/area"
                size="lg"
                theme="reg"
                target="_blank"
                class="prep__item-btn"
                rel="noopener noreferrer"
                >Все площадки</BaseButton
              >
            </div>
            <div class="prep__item">
              <h3 class="prep__item-title h4">Материалы для&nbsp;подготовки</h3>
              <h4 class="prep__item-subtitle">
                Мы&nbsp;собрали в&nbsp;одном месте все материалы, которые
                помогут вам выступить отлично
              </h4>
              <BaseButton
                tag="a"
                href="https://ntcontest.ru/study/materials"
                size="lg"
                theme="reg"
                target="_blank"
                class="prep__item-btn"
                rel="noopener noreferrer"
                >Материалы</BaseButton
              >
            </div>
            <div class="prep__item">
              <h3 class="prep__item-title h4">Сборники прошлых лет</h3>
              <h4 class="prep__item-subtitle">
                На&nbsp;нашем сайте вы&nbsp;найдете сборники задач
                по&nbsp;каждому профилю за&nbsp;все годы.
              </h4>
              <BaseButton
                tag="a"
                href="https://ntcontest.ru/study/problembooks"
                size="lg"
                theme="reg"
                target="_blank"
                class="prep__item-btn"
                rel="noopener noreferrer"
                >Сборники</BaseButton
              >
            </div>
            <div class="prep__item">
              <h3 class="prep__item-title h4">
                Курсы подготовки<br />по&nbsp;технологиям НТИ
              </h3>
              <h4 class="prep__item-subtitle">
                Наши курсы для самых увлеченных участников.
              </h4>
              <BaseButton
                tag="a"
                href="https://ntcontest.ru/study/ntitechnologies"
                size="lg"
                theme="reg"
                target="_blank"
                class="prep__item-btn"
                rel="noopener noreferrer"
                >Курсы</BaseButton
              >
            </div>
          </div>
        </section>

        <section
          id="to-mentors-and-teachers"
          class="section mentors">
          <h2 class="mentors__title h2">Для наставников и&nbsp;учителей</h2>
          <div class="mentors__row">
            <img
              class="mentors__img"
              src="@/assets/images/landing/mentors/mentors.webp"
              alt=""
              width="578px"
              height="552px" />
            <div class="mentors__content">
              <div class="mentors__info">
                <h2 class="mentors__info-title h2">
                  Для наставников и&nbsp;учителей
                </h2>
                <p>
                  В&nbsp;Личном кабинете наставника вы&nbsp;можете приглашать
                  учеников и&nbsp;отправлять им&nbsp;уведомления с&nbsp;просьбой
                  связаться. Вы&nbsp;сможете следить за&nbsp;их&nbsp;прогрессом
                  и&nbsp;видеть, каким темам и&nbsp;заданиям стоит уделить
                  больше внимания.
                </p>
                <p>
                  Даже если у&nbsp;вас много учеников, наблюдать за&nbsp;ними
                  будет удобно.
                </p>
              </div>
              <div class="mentors__btns">
                <BaseButton
                  tag="a"
                  :href="regLink"
                  theme="primary"
                  size="lg"
                  class="mentors__btn"
                  @click="
                    gtmEvent({
                      eventAction: 'become_mentor',
                    })
                  "
                  >Стать наставником</BaseButton
                >
                <BaseButton
                  tag="a"
                  href="https://ntcontest.ru/mentors/"
                  theme="reg"
                  size="lg"
                  class="mentors__btn"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Для наставника</BaseButton
                >
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>

    <AppFooter
      class="reg-layout__footer"
      variant="landing">
      <template #links>
        <a
          href="https://talent.kruzhok.org/policy"
          target="_blank"
          rel="noopener noreferrer"
          >Политика обработки персональных данных</a
        >
        <a
          href="https://talent.kruzhok.org/terms_of_use"
          target="_blank"
          rel="noopener noreferrer"
          >Пользовательское соглашение</a
        >
      </template>
    </AppFooter>
  </div>
</template>

<script>
import store from "@/store";
import {
  PARTICIPANT_ROLE,
  MENTOR_ROLE,
  REGISTRATION_STAGE,
  PRE_REG_ENABLED_BEFORE,
} from "@/constants";
import AppFooter from "@/layouts/AppFooter";
import LandingModal from "@/modals/LandingModal";
import { mapGetters, mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Hero from "@/components/landing/Hero.vue";
import ErrorModal from "@/modals/ErrorModal";
import BviButton from "@/components/BviButton.vue";
import { request } from "@/services/api";
import {
  TAGS,
  NTO_GOALS,
  ABOUT_NTO,
  TRACKS,
  BONUSES,
} from "@/constants/landing";
import dayjs from "@/plugins/dayjs";

const PRE_REG_EVENT = process.env.VUE_APP_PREREGISTRATION_EVENT_ID;

const SLIDER_OPTIONS = {
  observer: false,
  observeParents: false,
  loop: true,
  slidesPerView: "auto",
  loopedSlides: 5,
  spaceBetween: 10,
  speed: 5000,
  // allowTouchMove: false,
  autoplay: true,
};

// const START_TIME_SHIFT = 1000 * 60 * 60 * 3; // 3 часа шифт между началом олимпиады и открытием реги

export default {
  name: "LandingPage",
  components: { BviButton, Swiper, SwiperSlide, AppFooter, Hero },
  async beforeRouteEnter(to, from, next) {
    const user = store.state.user.user;
    const talentUser = store.state.user.talentUser;
    const nextRoute = to.query.next;
    let season;
    try {
      season = await store.dispatch("getSeason", { ignoreCache: true });
    } catch (error) {
      //
    }

    if (!season) {
      /**
       * Никуда не перенаправляем по умолчанию если олимпиада еще не началась
       */
      return next();
    }

    if (to.query.error) {
      return next();
    }

    // Пользователь авторизован в таланте и не зареган
    if (!user?.role && talentUser?.id) {
      next({
        name: "registration",
        query: to.query,
      });
      return;
    }

    if (user?.role === PARTICIPANT_ROLE) {
      if (user?.participant?.id && to.name !== "registration-profile") {
        next(
          nextRoute
            ? nextRoute
            : {
                name: "user-index",
              }
        );
        return;
      }
      if (!user?.participant?.id) {
        next({
          name: "registration",
          query: to.query,
        });
        return;
      }
    }

    if (user?.role === MENTOR_ROLE) {
      next({
        name: "mentor-index",
        query: to.query,
      });
      return;
    }

    next();
  },
  data() {
    return {
      showMenu: false,
      currentTime: Date.now(),
      startDate: null,
      timer: null,
      loading: true,
    };
  },
  metaInfo() {
    return {
      title: "Главная страница",
    };
  },
  computed: {
    ...mapState({
      season: "season",
    }),
    ...mapGetters({
      user: "user/user",
      isMentor: "user/isMentor",
      seasonStatus: "seasonStatus",
    }),
    swiperOptions() {
      return SLIDER_OPTIONS;
    },
    loginUrl() {
      if (this.seasonStatus !== "ended") {
        return `${this.$store.state.clientApiPrefix}/auth/go?next=/`;
      }
      return undefined;
    },
    regLink() {
      return `${this.$store.state.clientApiPrefix}/auth/go?next=/registration`;
    },
    isStarted() {
      return this.startDuration <= 0;
    },
    startDuration() {
      return this.startDate - this.currentTime;
    },
    registrationSchedule() {
      const schedule = this.$store.state.schedule || [];
      return schedule.filter((n) => n.stage === REGISTRATION_STAGE);
    },
    isAllRegClosed() {
      const { registrationSchedule } = this;
      const now = Date.now();
      if (!registrationSchedule.length) return true;
      return this.registrationSchedule.every((n) => {
        return n.end_at && now - new Date(n.end_at) > 0;
      });
    },
    preRegUrl() {
      if (!PRE_REG_EVENT) return;
      const url = `${process.env.VUE_APP_TALENT_BASE_URL}/registration?event=${PRE_REG_EVENT}`;
      if (this.startDuration > PRE_REG_ENABLED_BEFORE) {
        return url;
      }
      return url;
    },
    showRegButtons() {
      return (
        !this.isAllRegClosed &&
        this.isStarted &&
        !this.loading &&
        (this.regLink || this.loginUrl)
      );
    },
  },
  created() {
    this.TAGS = TAGS;
    this.NTO_GOALS = NTO_GOALS;
    this.ABOUT_NTO = ABOUT_NTO;
    this.TRACKS = TRACKS;
    this.BONUSES = BONUSES;
  },
  mounted() {
    if (this.season) {
      this.$store
        .dispatch("getSchedule")
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    } else {
      this.getLastSeason();
    }
    const { error, status, msg, url } = this.$route.query;
    if (error === "participant_data") {
      this.showError({
        title: "Ошибка",
        message: decodeURIComponent(msg),
        status,
        url: decodeURIComponent(url),
        content: `Не удалось получить данные участника и перейти в личный кабинет. Пожалуйста, попробуйте еще раз или <a class="link" href="/support">сообщите нам</a> об этой ошибке.`,
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    showError(data) {
      this.$modal.show(
        ErrorModal,
        {
          title: data.title,
          message: data.message,
          content: data.content,
          status: data.status,
          url: data.url,
          report: data.report,
        },
        {
          adaptive: true,
          scrollable: true,
          minHeight: 200,
          height: "auto",
        },
        {
          closed: () => {
            // eslint-disable-next-line no-unused-vars
            const { error, status, msg, url, ...rest } = this.$route.query;
            this.$router.push({ query: rest });
          },
        }
      );
    },
    handleCloseClick(e) {
      if (this.showMenu && !e.target.closest(".burger")) {
        this.showMenu = false;
        document.removeEventListener("click", this.handleCloseClick);
      }
    },
    handleBurger() {
      this.showMenu = !this.showMenu;
      if (this.showMenu) {
        this.$nextTick(() => {
          document.addEventListener("click", this.handleCloseClick, true);
        });
      }
    },
    gtmEvent(params) {
      window.dataLayer?.push({
        event: "ntoLandingEvent",
        eventCategory: "nto_landing_cta",
        ...params,
      });
    },
    showModal() {
      this.$modal.show(
        LandingModal,
        {},
        {
          adaptive: true,
          classes: "no-padding",
          width: "90%",
          height: "auto",
        }
      );
    },
    async getLastSeason() {
      const { season } = this;
      // Если есть текщий сезолн, то ничего считать не нужно
      if (season) {
        this.loading = false;
        return;
      }
      try {
        const { data } = await request({
          method: "GET",
          url: "/last-season",
        });
        this.runTimer(data?.start_at);
      } catch (error) {
        // делаем ничего
      }
      this.loading = false;
    },

    runTimer(startAt) {
      if (!startAt) return;

      const time = dayjs(startAt).add(3, "hours");
      const now = Date.now();
      this.startDate = time.valueOf();

      if (now <= this.startDate) {
        this.timer = setInterval(() => {
          this.currentTime = Date.now();
          if (this.currentTime > this.startDate) {
            clearInterval(this.timer);
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="less">
@header-height: 172px;
@header-height--mobile: 65px;
.video {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  max-width: none !important;
  user-select: none;
  pointer-events: none;
  opacity: 0.7;
  min-height: calc(100vh + @header-height);
  background-color: @black-menu;

  @media (max-width: @screen-md) {
    min-height: calc(100vh + @header-height--mobile);
  }
}
.l-page {
  --grid-gutter-width: 40px;
  color: @white-blue;
  background-color: @black-menu;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  overflow: hidden;
  position: relative;

  img {
    max-width: 100%;
  }

  .h1 {
    font-size: 80px;
    line-height: 0.8;
    font-weight: 600;
    margin-bottom: 0.75em;
  }

  .h2 {
    color: @azure-blue;
    font-size: 60px;
    line-height: 0.9;
    font-weight: 600;
    margin-bottom: 0.75em;
  }

  .h3 {
    font-size: 40px;
    line-height: 1;
    font-weight: 600;
    margin-bottom: 0.75em;
  }

  .h4 {
    font-size: 30px;
    line-height: 1.2;
    margin-bottom: 0.75em;
  }

  .base-btn:focus {
    outline: #fff solid 1px;
  }

  @media (max-width: @screen-lg) {
    .h1 {
      font-size: 60px;
    }

    .h2 {
      font-size: 50px;
    }

    .h3 {
      font-size: 35px;
    }

    .h4 {
      font-size: 27px;
    }
  }

  @media (max-width: @screen-md) {
    .h1 {
      font-size: 45px;
    }

    .h2 {
      font-size: 35px;
    }

    .h3 {
      font-size: 30px;
    }

    .h4 {
      font-size: 25px;
    }
  }

  @media (max-width: @screen-xs) {
    padding-bottom: 44px;
  }

  @media (max-width: 400px) {
    .h1 {
      font-size: 35px;
    }

    .h2 {
      font-size: 30px;
    }

    .h3 {
      font-size: 25px;
    }

    .h4 {
      font-size: 22px;
    }
  }

  @media (max-width: @screen-xxs) {
    .h4 {
      font-size: 20px;
    }
  }
}
</style>

<style lang="less" scoped>
@section-offset: 60px;

.section {
  padding: @section-offset 0;
}

.landing__title {
  color: @azure-blue;
  margin-bottom: 0;
}

.about {
  padding-bottom: 160px;
  overflow: hidden;

  &__box {
    display: flex;
    flex-direction: column;
    gap: 48px;
  }

  &__cell {
    display: flex;
    gap: 12px;

    &-block {
      display: grid;
      grid-template-columns: 1fr;
      gap: 12px;
    }

    &-header {
      font-size: 120px;
      font-style: normal;
      font-weight: 600;
      line-height: 0.5;
      letter-spacing: -4.8px;
      color: @azure-blue;
    }

    &-footer {
      align-self: flex-end;
      transform: translateY(-10px);
      & p:first-of-type {
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: 146%; /* 32.12px */
        text-transform: uppercase;
      }
      & p:last-of-type {
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 126%;
      }
    }
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
    margin-top: 64px;
  }

  &__count {
    display: flex;

    &-number {
      font-size: 240px;
      font-weight: 300;
      line-height: 180px;
      color: @azure-blue;
      margin-bottom: 0;
      letter-spacing: -9.6px;
    }

    &-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        margin-bottom: 10px;
      }

      span {
        color: #017aff;
        font-weight: bold;
      }
    }
  }

  &__icons {
    flex-shrink: 0;
  }

  &__panel {
    display: flex;
    justify-content: space-between;
    gap: 32px;
    margin-top: 64px;
    padding: 48px;
    background-color: @dark-blue;

    &-img {
      flex-shrink: 0;
      aspect-ratio: 358 / 320;
      width: 100%;
      max-width: 358px;
    }

    &-box {
      display: flex;
      flex-direction: column;
      gap: 20px;
      // flex-grow: 1;
    }

    &-list {
      display: flex;
      flex-direction: column;
      gap: 20px;

      &-item {
        display: flex;
        gap: 20px;

        & img {
          flex-shrink: 0;
          width: 29px;
          height: 32px;
        }

        & p {
          font-size: 22px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }

    &-title {
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: 90%; /* 32.4px */
      letter-spacing: -0.72px;
      margin-bottom: 12px;
      color: @azure-blue;
    }
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
    margin-top: 128px;
  }

  &__tag {
    flex-grow: 1;
    position: relative;
    max-width: 90%;
    display: inline-flex;
    align-items: center;
    color: #fff;
    line-height: 16px;
    padding: 10px 60px 10px 25px;
    padding-left: 45px;
    border-radius: 42px;
    clip-path: polygon(0 0, 90% 0%, 100% 80%, 100% 100%, 0 100%, 0 45%);
    margin-bottom: 12px;
    flex-grow: 0;
    flex-shrink: 1;
    font-size: 24px;
    font-weight: 600;
    line-height: 110%;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 12px;
      bottom: 0;
      width: 20px;
      height: 20px;
      margin: auto;
      background-image: url("../assets/images/landing/participants/icon_star.svg");
    }

    &::after {
      position: absolute;
      content: "";
      width: 70px;
      height: 70px;
      background-color: #000;
      opacity: 0.5;
      border-radius: 50%;
      top: -17px;
      left: 97%;
      transform: translateX(-30px);
    }

    &:nth-child(1) {
      background-color: #fe7224;
    }

    &:nth-child(2) {
      background-color: #48cc4e;
    }

    &:nth-child(3) {
      background-color: #00a5e2;
    }
    &:nth-child(4) {
      background-color: #ef4b81;
    }
    &:nth-child(5) {
      background-color: #a05eb5;
    }
    &:nth-child(6) {
      background-color: #6678f0;
    }
    &:nth-child(7) {
      background-color: #00b2a9;
    }
  }

  @media (max-width: @screen-md) {
    &__panel {
      flex-direction: column;
      padding: 24px;
      align-items: center;

      &-title {
        font-size: 30px;
      }

      &-list-item {
        & p {
          font-size: 20px;
        }
      }
    }
  }

  @media (max-width: @screen-xs-max) {
    padding-bottom: 96px;

    &__tag {
      width: 100%;
      font-size: 16px;
    }

    &__row {
      flex-direction: column;
      gap: 32px;
      align-items: center;
      margin-top: 48px;
    }
    &__count-number {
      font-size: 140px;
      font-weight: 300;
      line-height: 100px;
      color: @azure-blue;
      margin-bottom: 0;
      letter-spacing: -9.6px;
    }

    &__cell {
      &-header {
        font-size: 80px;
        font-style: normal;
        font-weight: 600;
        line-height: 0.5;
        letter-spacing: -4.8px;
        color: @azure-blue;
      }

      &-footer {
        transform: translateY(0);
      }
    }

    &__icons {
      img {
        max-width: none;
      }
    }
  }

  @media (max-width: @screen-xs) {
    &__row {
      align-items: flex-start;
    }
  }

  @media (max-width: @screen-xxs) {
    &__count {
      &-number {
        font-size: 180px;
        margin-left: -0.1em;
      }

      img {
        display: block;
        max-width: 60px;
      }
    }
  }
}

.tracks {
  &__subtitle {
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 146%;
    margin-top: 30px;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 48px;
    margin-bottom: 48px;
  }
  &__item {
    position: relative;
    background-color: #082d7b; /* синий фон карточки */
    padding: 30px;
    color: #fff;
    overflow: hidden;
    display: flex;
    gap: 36px;

    & img {
      flex-shrink: 0;
      width: 145px;
      height: 51px;
    }
    &-title {
      color: @azure-blue;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 146%;
    }
    &-for {
      font-size: 30px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 20px;
      max-width: 700px;
    }
    &-list {
      width: 100%;
      display: flex;
      flex-direction: column;

      &-item {
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        display: flex;
        gap: 10px;
        & span:first-of-type {
          flex-shrink: 0;
          color: @azure-blue;
        }

        & + & {
          margin-top: 6px;
        }
      }
    }

    &-link {
      color: @azure-blue;
      text-decoration: none;
      margin-top: 20px;
      display: block;
      transition: color 0.3s;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;

      &:hover {
        color: lighten(@azure-blue, 20%);
      }
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border-top: 32px solid #00031d; /* цвет треугольника */
      border-left: 32px solid transparent;
    }
  }

  &__buttons {
    display: flex;
    gap: 10px;
  }

  @media (max-width: @screen-md) {
    &__buttons {
      flex-direction: column;
    }
  }

  @media (max-width: @screen-xs-max) {
    &__subtitle {
      font-size: 20px;
      margin-top: 16px;
    }
    &__item {
      flex-direction: column;
      padding: 24px;
      gap: 24px;

      &-title {
        font-size: 16px;
      }
      &-for {
        font-size: 24px;
      }
      &-list {
        &-item {
          font-size: 16px;
        }
      }
      &-link {
        font-size: 16px;
      }
    }
  }

  @media (max-width: @screen-xs) {
    &__btn-reg {
      display: none;
    }
  }
}

.bonuses {
  margin-top: 192px;

  &__list {
    margin-top: 48px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  &__item {
    display: flex;
    flex-basis: calc(50% - 32px);
    padding: 32px;
    gap: 32px;
    background-color: #03103c;
    & img {
      flex-shrink: 0;
      width: 82px;
      height: auto;
      align-self: flex-start;
    }

    &-content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }

    &-title {
      font-size: 30px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    &-description {
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 146%;

      & b {
        font-weight: 700;
      }
    }
    &-details {
      display: flex;
      gap: 10px;
    }
    &-detail {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 4px;

      & p:first-of-type {
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: 146%; /* 32.12px */
        text-transform: uppercase;
        color: @azure-blue;
      }

      & p:last-of-type {
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 126%;
      }
    }
  }

  @media (max-width: @screen-lg) {
    &__item {
      flex-direction: column;
    }
  }

  @media (max-width: @screen-xs-max) {
    margin-top: 96px;

    &__list {
      margin-top: 32px;
    }
    &__item {
      flex-basis: 100%;
      padding: 24px;
      gap: 24px;

      & img {
        width: 60px;
      }

      &-title {
        font-size: 24px;
      }
      &-description {
        font-size: 16px;
      }
      &-detail {
        & p:last-of-type {
          font-size: 16px;
        }
      }
    }
  }
}
.burger {
  display: block;
  position: relative;
  width: 34px;
  height: 24px;
  border: none;
  background: none;
  padding: 0;

  &:focus {
    outline: none;
  }

  &::before,
  &::after {
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    margin: auto;
    transition: transform 0.3s;
  }

  &__line,
  &::before,
  &::after {
    width: 100%;
    height: 2px;
    background-color: #fff;
  }

  &__line {
    transition: opacity 0.3s;
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
  }

  &.active &__line {
    display: none;
  }

  &.active {
    &::before,
    &::after {
      top: 0;
      bottom: 0;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }
}
.extras {
  &__title {
    margin-bottom: 1.25em;
  }

  &__row {
    display: flex;
    justify-content: space-between;
  }

  &__item {
    flex-basis: 50%;

    &-icon {
      display: flex;
      width: 102px;
      height: 102px;
      align-items: center;
      margin-bottom: 30px;
    }
  }

  @media (max-width: @screen-sm-max) {
    &__row {
      display: block;
    }

    &__item {
      margin-bottom: 60px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.features {
  padding-top: 100px;
  padding-bottom: 20px;

  h3 {
    color: #8eb5ff;
    margin-bottom: 0.4em;
  }

  p {
    margin-bottom: 0;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    &:nth-child(2n) {
      flex-direction: row-reverse;
    }

    &-content {
      width: 40%;
      align-self: center;
    }

    &-stage {
      text-align: center;
      width: 40%;
    }
  }

  @media (max-width: @screen-xs-max) {
    padding-bottom: 60px;

    &__item {
      display: block;
      margin-bottom: 80px;

      &-content,
      &-stage {
        width: auto;
      }

      &-stage {
        margin-bottom: 40px;
      }
    }
  }
}
.features-slider {
  cursor: pointer;
  .swiper-wrapper {
    transition-timing-function: linear;
  }

  .swiper-slide {
    width: auto;
    min-width: 434px;
    margin-right: 10px;
  }

  &__slide {
    text-align: center;

    &-img {
      position: relative;
      padding-bottom: 58.52%;
      margin-bottom: 15px;

      &::before {
        position: absolute;
        content: "";
        left: 0;
        right: 0;
        bottom: 0;
        height: 8px;
        background-color: white;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 1;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        user-select: none;
        pointer-events: none;
        object-fit: cover;
      }
    }

    p {
      display: inline-block;
      position: relative;
      padding-left: 25px;
      user-select: none;
      pointer-events: none;

      &::before {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 13px;
        height: 13px;
        border: 3px solid white;
        border-radius: 50%;
      }
    }

    &:nth-child(5n + 1) &-img::before {
      background-color: #ff630d;
    }

    &:nth-child(5n + 1) p::before {
      border-color: #ff630d;
    }

    &:nth-child(5n + 2) &-img::before {
      background-color: #00cb51;
    }

    &:nth-child(5n + 2) p::before {
      border-color: #00cb51;
    }

    &:nth-child(5n + 3) &-img::before {
      background-color: #0056ff;
    }

    &:nth-child(5n + 3) p::before {
      border-color: #0056ff;
    }

    &:nth-child(5n + 4) &-img::before {
      background-color: #ff45aa;
    }

    &:nth-child(5n + 4) p::before {
      border-color: #ff45aa;
    }

    &:nth-child(5n + 5) &-img::before {
      background-color: #d200ff;
    }

    &:nth-child(5n + 5) p::before {
      border-color: #d200ff;
    }
    &:nth-child(5n + 6) &-img::before {
      background-color: #00a5e2;
    }

    &:nth-child(5n + 6) p::before {
      border-color: #00a5e2;
    }
    &:nth-child(5n + 7) &-img::before {
      background-color: #00b2a9;
    }

    &:nth-child(5n + 7) p::before {
      border-color: #00b2a9;
    }
    &:nth-child(5n + 8) &-img::before {
      background-color: #ef4b81;
    }

    &:nth-child(5n + 8) p::before {
      border-color: #ef4b81;
    }
  }

  @media (max-width: @screen-xs-max) {
    .swiper-slide {
      min-width: 340px;
    }
  }
}
.header {
  position: relative;
  padding: 65px 0;
  z-index: 1;

  a {
    color: @white-blue;
  }

  &__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  &__logo {
    width: 182px;
    aspect-ratio: ~"182 / 48";
    height: auto;
    order: -1;

    &-img {
      width: 100%;
      height: 100%;
    }

    &-square {
      display: none;
    }
  }

  &__nav {
    display: flex;
    justify-content: center;

    &-item {
      text-align: center;
      font-size: 14px;
      letter-spacing: 0.19em;
      font-weight: 600;
      text-decoration: none;
      text-transform: uppercase;
      margin-right: 40px;
      transition: color 0.3s;

      &:hover {
        color: #fff;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__burger {
    order: 2;
    display: none;
  }

  @media (max-width: @screen-lg) {
    &__nav {
      &-item {
        margin-right: 25px;
      }
    }
  }

  @media (max-width: @screen-md) {
    padding: 25px 0;
    background-color: transparent;
    z-index: 10;

    &.open {
      background-color: @black-menu;
    }

    &__inner {
      position: relative;
    }

    &__logo {
      position: relative;
      width: 51px;
      margin: 0;
      z-index: 11;
      aspect-ratio: ~"592 / 555";

      &-square {
        display: block;
      }
      &-horizontal {
        display: none;
      }
    }

    &__burger {
      display: block;
    }

    &__nav {
      display: block;
      position: fixed;
      right: 100%;
      bottom: 100%;
      opacity: 0;
      visibility: hidden;
      overflow: hidden;
      z-index: 10;
      background-color: @black-menu;
      text-align: center;
      padding: 20px 0;
      box-shadow: 1px 2px 2px 0 rgba(0, 0, 0, 0.5);

      &-item {
        &:nth-child(3) {
          margin-right: 0;
        }

        display: block;
        margin-right: 0;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      &.active {
        top: 80px;
        left: 0;
        right: 0;
        bottom: 0;
        width: auto;
        height: auto;
        visibility: visible;
        opacity: 1;
        animation: fadein 0.3s;
        animation-direction: alternate;
        animation-fill-mode: both;
      }
    }
  }
}

.mentors {
  &__title {
    display: none;
    color: @azure-blue;
  }

  &__row {
    display: flex;
    align-items: center;
  }

  &__img {
    order: 1;
    max-width: 50%;
    height: auto;
  }

  &__content {
    margin-right: 55px;
  }

  &__info {
    margin-bottom: 60px;

    p {
      margin-bottom: 1.5em;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__btns {
    display: flex;
    flex-wrap: wrap;
    margin: -10px;
  }

  &__btn {
    flex-grow: 1;
    margin: 10px;
  }

  @media (max-width: @screen-sm-max) {
    &__title {
      display: block;
      color: @azure-blue;
    }

    &__row {
      display: block;
    }

    &__content {
      margin-right: 0;
    }

    &__info {
      &-title {
        display: none;
        color: @azure-blue !important;
      }
    }

    &__img {
      display: block;
      max-width: 100%;
      margin: 0 auto;
      margin-bottom: 35px;
    }

    &__info {
      margin-bottom: 40px;
    }
  }
}
.participants {
  &__row {
    display: flex;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-right: -20px;
    align-items: stretch;
  }

  &__item {
    width: 425px;
    min-height: 410px;
    padding: 20px;
    position: relative;

    &:nth-child(3) {
      margin-left: auto;
    }
  }

  @media (max-width: @screen-sm-max) {
    &__item {
      padding: 10px;
      width: 50%;
      min-height: 330px;
    }

    &__row {
      margin: -10px;
    }
  }

  @media (max-width: @screen-xs-max) {
    &__item {
      width: 100%;
      max-width: 500px;
      height: auto;
    }

    &__item:nth-child(even) {
      margin-left: auto;
    }
    &__item:nth-child(odd) {
      margin-left: 0;
    }
  }

  @media (max-width: @screen-xxs) {
    &__item {
      width: 100%;
      height: auto;
    }
  }
}

.participant-card {
  position: relative;
  min-height: 100%;

  &__title {
    font-size: 25px;
    margin-bottom: 0.6em;
  }

  &__dots {
    position: absolute;
    width: 6px;
    height: 20px;
    background-color: @black-menu;
    border-radius: 3px;
    bottom: 30px;
    left: 30px;
    z-index: 0;
    box-shadow: 70px 0px 0px 0px @black-menu, 97px 0px 0px 0px @black-menu,
      117px 0px 0px 0px @black-menu, 166px 0px 0px 0px @black-menu,
      189px 0px 0px 0px @black-menu, 214px 0px 0px 0px @black-menu,
      236px 0px 0px 0px @black-menu, 284px 0px 0px 0px @black-menu,
      332px 0px 0px 0px @black-menu, 355px 0px 0px 0px @black-menu;
  }

  &__inner {
    position: relative;
    z-index: 1;
    padding: 35px 30px;
    padding-bottom: 90px;
    min-height: 100%;

    &::after {
      position: absolute;
      width: 30px;
      right: 0;
      top: 153px;
      height: 14px;
      content: "";
      border-radius: 7px 0 0 7px;
      background-color: @black-menu;
      transform: translateY(18px);
    }
  }

  &::before {
    content: "";
    position: absolute;
    clip-path: polygon(0% 0%, 84% 0, 100% 20%, 100% 100%, 0% 100%);
    width: 100%;
    background-color: fade(#1c1c7a, 90%);
    height: 100%;
    border-radius: 4px;
  }

  &__icon {
    height: 52px;
    margin-bottom: 30px;
  }

  &__name {
    margin-bottom: 0.4em;
  }

  @media (max-width: @screen-sm-max) {
    &__inner {
      padding: 25px 30px 70px 30px;
    }

    &__icon {
      max-width: 120px;
      height: 42px;
    }

    &__title {
      font-size: 20px;
    }

    &__list {
      font-size: 16px;
    }
  }

  @media (max-width: @screen-xxs) {
    &__icon {
      max-width: 100px;
      margin-bottom: 20px;
    }
  }
}
.participant-cta {
  position: relative;
  // border: 1px solid #fff;
  border-radius: 5px;
  // clip-path: polygon(0 0, 83% 0, 100% 18.2%, 100% 100%, 0 100%, 0 0);
  background-color: #fff;
  position: relative;
  border-radius: 4px;
  min-height: 100%;
  clip-path: polygon(0% 0%, 84% 0, 100% 20%, 100% 100%, 0% 100%);

  .participant-card__title {
    padding-right: 23px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 1px;
    left: 1px;
    right: 1px;
    bottom: 1px;
    background-color: @black-menu;
    display: block;
    border-radius: 4px;
    clip-path: polygon(0% 0%, 84% 0, 100% 20%, 100% 100%, 0% 100%);
  }

  &__inner {
    padding: 30px 40px;
    position: relative;
    z-index: 1;
  }

  &__features {
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
    align-items: self-start;
  }

  &__feature {
    position: relative;
    max-width: 90%;
    display: inline-flex;
    align-items: center;
    height: 48px;
    color: #fff;
    line-height: 16px;
    padding: 5px 35px;
    padding-left: 45px;
    border-radius: 30px;
    clip-path: polygon(0 0, 90% 0%, 100% 80%, 100% 100%, 0 100%, 0 45%);
    margin-bottom: 12px;
    flex-grow: 0;
    flex-shrink: 1;
    font-size: 16px;
    font-weight: bold;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 12px;
      bottom: 0;
      width: 20px;
      height: 20px;
      margin: auto;
      background-image: url("../assets/images/landing/participants/icon_star.svg");
    }

    &::after {
      position: absolute;
      content: "";
      width: 48px;
      height: 48px;
      background-color: #000;
      opacity: 0.5;
      border-radius: 50%;
      top: -11px;
      left: 100%;
      transform: translateX(-30px);
    }

    &:nth-child(1) {
      margin-left: auto;
      background-color: #0ec855;
    }

    &:nth-child(2) {
      background-color: #aa00ce;
    }

    &:nth-child(3) {
      margin-left: auto;
      background-color: #fe7224;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: @screen-sm-max) {
    &__inner {
      padding: 20px 25px;
    }
    &__features {
      margin-bottom: 18px;
    }

    &__feature {
      height: 38px;
    }
  }
}
.past-olympiad {
  .video-poster {
    max-width: 900px;
    background-image: url("../assets/images/landing/poster.png");
    background-size: cover;
    // background-color: fade(#000, 0.2);
    cursor: pointer;
    margin-left: auto;
    margin-right: auto;
    margin-top: 160px;

    &::before {
      content: "";
      display: block;
      padding-top: percentage(1080/1920);
    }

    @media (max-width: @screen-sm-max) {
      margin-top: 96px;
    }
  }
}

.prep {
  margin-top: 160px;
  &__row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 16px;
    margin-top: 48px;
  }

  &__item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex-basis: calc(25% - 48px);
    padding: 32px;
    background-color: @dark-blue;

    &-subtitle {
      margin-bottom: 1.5em;
    }

    &-btn {
      // padding: 0 65px;
      min-width: 200px;
    }
  }

  @media (max-width: @screen-sm-max) {
    &__row {
      margin-top: 32px;
      flex-direction: column;
    }

    &__item {
      flex-basis: 100%;
      padding: 24px;
    }
  }

  @media (max-width: @screen-xs) {
    &__item {
      padding: 25px 20px;
      padding-bottom: 30px;

      &-btn {
        width: 100%;
        padding: 0 20px;
      }
    }
  }
}
.social {
  &__list {
    display: flex;
  }

  &__item {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    background-color: #0c0c28;
    border-radius: 50%;
    transition: background-color 0.3s;
    margin-right: 18px;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      background-color: lighten(#0c0c28, 10%);
    }
  }
}
.steps {
  counter-reset: step;

  &__row {
    display: flex;
    justify-content: space-between;
  }

  &__item {
    flex-basis: 30%;

    &-head {
      position: relative;
      padding-left: 85px;

      &::before {
        color: @black-menu;
        counter-increment: step;
        content: counter(step);
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 40px;
        font-weight: 600;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        width: 62px;
        height: 62px;
        border-radius: 50%;
        background-color: #15d860;
      }
    }

    &:nth-child(2) &-head::before {
      background-color: #c237f2;
    }

    &:nth-child(3) &-head::before {
      background-color: @accent-blue;
    }

    &-img {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 205px;
      margin-bottom: 45px;

      img {
        height: auto;
      }
    }

    &-name {
      margin-bottom: 3px;
    }
  }

  @media (max-width: @screen-sm-max) {
    &__row {
      display: block;
    }

    &__item {
      margin-bottom: 80px;

      &:nth-child(2) {
        margin-top: -40px;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.special-button {
  & ::v-deep .bvi-text {
    display: none;
  }

  @media (max-width: @screen-md) {
    order: 1;
    margin-left: auto;
    margin-right: 10px;
  }
}
</style>
